import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box, Button, CssBaseline, ThemeProvider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import { selectOrganisation } from '@/app/slices/organisationSlice'
import { theme as lightTheme } from '@/common/themes/LightTheme'
import { StoreThemeOverride } from '@/common/themes/overrides/StoreThemeOverride'

import PublicAppBar from '../../AppBar/PublicAppBar'

const classes = {
    root: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: (theme) => `1px ${theme.palette.grey[300]} solid`,
        width: '100%',
        height: 'calc(100vh - 154px)',
        gap: 3,
    },
    sorryImage: {
        width: '700px',
    },
    sorryMessage: {
        gap: 1,
    },
}

const ErrorPageContainer = ({ linkHref, linkText, subtitle, title }) => {
    const { t } = useTranslation()
    const storeSettings = useSelector(selectOrganisation)

    const theme = useMemo(
        () => (storeSettings ? StoreThemeOverride(lightTheme, storeSettings) : lightTheme),
        [storeSettings]
    )

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <PublicAppBar />
            <Grid
                component="section"
                flex={1}
                justifyContent="center"
                padding={3}
                size={12}
                container
            >
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 12,
                        },
                        classes.root,
                    ]}
                >
                    <Box
                        alt="Sorry"
                        component="img"
                        src="sorry.svg"
                        sx={classes.sorryImage}
                    />

                    <Box
                        sx={[
                            {
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            },
                            classes.sorryMessage,
                        ]}
                    >
                        <Typography variant="h4">{t(title)}</Typography>
                        <Typography variant="body2">{t(subtitle)}</Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => {
                            window.location.href = linkHref
                        }}
                    >
                        {t(linkText)}
                    </Button>
                </Box>
            </Grid>
        </ThemeProvider>
    )
}

ErrorPageContainer.propTypes = {
    linkHref: PropTypes.string,
    linkText: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
}

export default ErrorPageContainer
